import { z } from "zod";
import { AwUserIdSchema } from "../traits/aw/awUserId.trait";

export enum ExtractUserSchemaEnum {
	ExtractUser = "ExtractUser"
};

export const ExtractUserSchema = AwUserIdSchema
	.merge(z.object({
		"@id": z.string(), // "/api/extract_users/1"
		"@type": z.string(), // "ExtractUser"
		id: z.number(), // 1
		first_name: z.string(), // "Marine"
		last_name: z.string(), // "Durif"
		is_archived: z.string(), // "0" | "1"
		email: z.string(), // "marine-durig@fake.com"
	}))
	.describe(ExtractUserSchemaEnum.ExtractUser);

export type ExtractUser = z.infer<typeof ExtractUserSchema>;
